import {
    useState,
    useEffect
} from 'react'
import { useDialogs } from '@shared/hooks/dialogs'
import { useMethods } from '@shared/hooks/methods'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import axios from '@shared/utils/axios'

export default function Search({ onClose }) {
    const [options, setOptions] = useState([])
    const [loading, setLoading] = useState(false)
    const [value, setValue] = useState('')
    const [selectedId, setSelectedId] = useState(null)
    const { show } = useDialogs()
    const { showMessage } = useMethods()

    useEffect(() => {
        const timer = setTimeout(async () => {
            if (!value.trim()) {
                setOptions([])
                return
            }
            setLoading(true)
            try {
                const res = await axios.get(`/estimations/search/?q=${encodeURIComponent(value)}`)
                setOptions(res.data)
            } catch (error) {
                showMessage({ text: 'حدث خطأ' })
            } finally {
                setLoading(false)
            }
        }, 300)
        return () => clearTimeout(timer)
    }, [value])

    return (
        <Autocomplete
            freeSolo
            disableCloseOnSelect
            options={options}
            value={null}
            inputValue={value}
            filterOptions={(x) => x}
            onInputChange={(e, newValue, reason) => {
                if (reason === 'input' || reason === 'clear') {
                    setValue(newValue)
                }
            }}
            sx={{ flexGrow: 1 }}
            loading={loading}
            getOptionLabel={(option) =>
                typeof option === 'string'
                    ? option
                    : `${option.number} - ${option.contractor}`
            }
            onChange={(e, option) => {
                if (typeof option !== 'object' || option === null) return
                setSelectedId(option.id)
                show(
                    option.is_draft ? 'estimation' : 'previewEstimation',
                    option
                )
            }}
            renderOption={(props, option) => {
                const { key, ...rest } = props
                const isSelected = option.id === selectedId
                return (
                    <Box
                        component="li"
                        key={key}
                        {...rest}
                        sx={{
                            ...(isSelected && {
                                backgroundColor: 'action.selected'
                            })
                        }}
                    >
                        {`${option.number} - ${option.contractor}`}
                    </Box>
                )
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    onBlur={() => {
                        if (value.trim() === '') onClose()
                    }}
                    autoFocus
                    size="small"
                    placeholder="ابحث..."
                />
            )}
        />
    )
}